import { Card, IconButton, Dropdown, Filter, ButtonType, IconSize, OverlayMode } from '@soteria/design-system-ve';

import * as styles from './AuditItemsFilters.css';
import type { AuditItemPagination } from './types';
import { PAGE_SIZE_OPTIONS } from './types';

interface FilterBarProps {
  filteredCount?: number;
  totalCount?: number;
  isLoading: boolean;
  isFilterExpanded: boolean;
  filtersActive: boolean;
  activeFilterCount: number;
  pagination: AuditItemPagination;
  onFilterToggle: () => void;
  onPageSizeChange: (selectedItem: string) => void;
}

/**
 * Main filter bar component with results count and controls
 * Contains filter toggle button and page size dropdown
 */
export function FilterBar({
  filteredCount,
  totalCount,
  isLoading,
  isFilterExpanded,
  filtersActive,
  activeFilterCount,
  pagination,
  onFilterToggle,
  onPageSizeChange,
}: FilterBarProps) {
  return (
    <Card padding="medium">
      <div className={styles.mainFilterBar}>
        <div className={styles.filterBarLeft}>
          {filteredCount !== undefined && totalCount !== undefined && (
            <div className={styles.filterResults}>
              {filteredCount === totalCount ? (
                <span>{totalCount} items</span>
              ) : (
                <span>
                  {filteredCount} of {totalCount} items
                </span>
              )}
            </div>
          )}
        </div>

        <div className={styles.controlGroup}>
          {/* Filter Toggle Button */}
          <IconButton
            aria-label={isFilterExpanded ? 'Hide filters' : 'Show filters'}
            buttonType={ButtonType.Secondary}
            className={styles.filterButton}
            data-active={isFilterExpanded}
            data-has-filters={filtersActive}
            disabled={isLoading}
            icon={Filter}
            iconSize={IconSize.Small}
            overlayMode={OverlayMode.Solid}
            title={`${isFilterExpanded ? 'Hide' : 'Show'} filters${filtersActive ? ` (${activeFilterCount} active)` : ''}`}
            onClick={onFilterToggle}
          />

          {/* Page Size Dropdown */}
          <Dropdown
            className={styles.pageSizeDropdown}
            disabled={isLoading}
            options={PAGE_SIZE_OPTIONS}
            placeholder="Page size..."
            selectedItem={pagination.pageSize.toString()}
            size="medium"
            onSelectionChange={onPageSizeChange}
          />
        </div>
      </div>
    </Card>
  );
}
